import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
} from '@angular/core';
import {StorageManager} from '../../storage-manager.class';

import { RequestHandler } from 'src/app/service/OffService/request-handler';

export enum RequestButtonTypes {
    NEW,
    EDIT,
    DELETE
}
@Component({
    selector: 'app-request-button',
    standalone: false,
    templateUrl: './request-button.component.html',
    styleUrls: ['./request-button.component.scss']
})


export class RequestButtonComponent<T> implements OnInit {

    @Input() request = new RequestHandler<T>();
    @Input() lockOnSuccess = false;
    @Input() error: string | null = null;
    @Input() warning: string | null = null;
    @Input() mode: RequestButtonTypes = 0;
    @Output() clicked: EventEmitter<object> = new EventEmitter<object>();

    public failMessage: string[] = [];

    public REQUEST_BUTTON_TYPES = RequestButtonTypes;

    constructor() {
    }

    ngOnInit() {
            
        if (!this.mode) {
            this.mode = RequestButtonTypes.NEW;
        }

        if ((StorageManager.getUser() || {}).rol === 'demo') {
            this.failMessage[0] = 'Operación no permitida para usuarios demo';
            this.failMessage[1] = '';
        } else {
            this.failMessage[0] = 'No hemos podido completar la operación';
            this.failMessage[1] = 'Revisa los datos e inténtalo de nuevo';
        }
    }

    public requestClick() {
        //this.requestClick.emit();
    }

}
